<ngx-ui-loader></ngx-ui-loader>
<div class="container-fluid" style="padding: 0 1.8rem 1.8rem">
    <h5>Maintenance Planning</h5>
    <div class="row">
        <div class="col-md-12">
          <div>
            <div class="example-button-row">
              <button mat-raised-button color="primary" (click)="addMaintainancePlanning('add','')">Schedule Planning</button>
            </div>
            <div fxLayout fxLayoutAlign="center center">
              <mat-form-field fxFlex="40%">
                <input matInput type="text" (keyup)="doFilter($event.target.value)" placeholder="Search">
              </mat-form-field>
            </div>

            <div class="table-container">
              <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort>
            
                <!-- Sitename Column -->
                <ng-container matColumnDef="sitename">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Site Name </th>
                  <td mat-cell *matCellDef="let element"> {{ element.sitename }} </td>
                </ng-container>
            
                <!-- Transformer ID Column -->
                <ng-container matColumnDef="transformerid">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Transformer ID </th>
                  <td mat-cell *matCellDef="let element"> {{ element.transformerid }} </td>
                </ng-container>
            
               
                <!-- Date Column -->
                <ng-container matColumnDef="date">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
                  <td mat-cell *matCellDef="let element"> {{ element.date | date:'short' }} </td>
                </ng-container>
            
               
                <!-- Engineer Name Column -->
                <ng-container matColumnDef="engineername">
                  <th mat-header-cell *matHeaderCellDef> Engineer Name </th>
                  <td mat-cell *matCellDef="let element"> {{ element.engineername }} </td>
                </ng-container>
            
                
            
                <!-- Downtime Column -->
                <ng-container matColumnDef="downtime">
                  <th mat-header-cell *matHeaderCellDef> Downtime </th>
                  <td mat-cell *matCellDef="let element"> {{ element.downtime }}  </td>
                </ng-container>
            
                <!-- Estimated Cost Column -->
                <ng-container matColumnDef="estimatedcost">
                  <th mat-header-cell *matHeaderCellDef> Estimated Cost </th>
                  <td mat-cell *matCellDef="let element"> {{ element.estimatedcost | currency:'INR':'symbol' }} </td>
                </ng-container>

                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef> Status </th>
                  <td mat-cell *matCellDef="let element"><b [ngStyle]="{color:element.status == 'Pending' ? '#F7CB73':'green'}"> {{element.status}} </b></td>
                </ng-container>
            
               
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Actions </th>
                  <td mat-cell *matCellDef="let element">
                    <button mat-icon-button color="warn" (click)="deleteData(element)">
                      <mat-icon class="mat-18">delete</mat-icon>
                  </button>
                      <button (click)="addMaintainancePlanning('edit',element)" mat-icon-button color="primary" >
                        <mat-icon class="mat-18">visibility</mat-icon>
                    </button>
                  </td>
                </ng-container>
  
                <!-- Header and Row Definition -->
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              </table>
            
              <!-- Pagination -->
              <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
            </div>
            
          </div>
        </div>

    </div>
    </div>
